<template>
  <div class="mm-page-main">
    <div class="page-header">
      <div class="page-title">門市現金賬戶</div>

    </div>

    <div v-if="stores.length>0" class="mm-tabs">
      <div class="mm-tabsulbox">
        <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
        <ul :style="transform" class="mm-tabs-card">
          <li @click.stop="changestore(store.id)" :class="{active:store_id == store.id}" v-for="(store,index) in stores" :key="index">{{store.name}}</li>
        </ul>
        <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="mm-tabs-content">
        <div class="mm-tab-hedaer">
          <div class="mm-tab-title">
            <h3>現金</h3>
          </div>

        </div>
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="data" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="name" label="貨幣" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">貨幣</div>
                <div style="display: flex; align-items:flex-end; ">
                  <div><img style="display: block; width: 30px; height: 30px;" :src="apiurl+scope.row.thumb"></div>
                  <div style="margin-left: 10px;">{{scope.row.name}}</div>
                  <div style="margin-left: 10px;">{{scope.row.short_name}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="money" label="貨幣結餘" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">貨幣結餘</div>
                <span>{{tomoney(scope.row.money)}} {{scope.row.short_name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="costrate" label="成本價" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">成本價</div>
                <span>{{scope.row.costrate}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="hkd" label="折合港幣" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">折合港幣</div>
                <span>{{tomoney(scope.row.hkd)}}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="income_money" label="客戶結餘(應收)" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">客戶結餘(應收)</div>
                <span>{{tomoney(scope.row.income_money)}} {{scope.row.short_name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="pay_money" label="客戶結餘(應付)" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">客戶結餘(應付)</div>
                <span>{{tomoney(scope.row.pay_money)}} {{scope.row.short_name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="surplus_money" label="結餘" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">結餘</div>
                <span>{{tomoney(scope.row.surplus_money)}} {{scope.row.short_name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="surplus_hkd" label="港幣結餘" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">港幣結餘</div>
                <span>{{tomoney(scope.row.surplus_hkd)}} HKD</span>
              </template>
            </el-table-column>
            <!-- <el-table-column  label="操作" align="center">
							<template slot-scope="scope">
								<el-button size="mini" @click="edit(scope.row)">修改</el-button>
							</template>
		
						</el-table-column> -->
          </el-table>
          <div class="tabletotal">
            <span>總結</span>
            <span>{{tomoney(surplus_hkd_total)}} HKD</span>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {

  data () {
    return {
      loading: false,
      store_id: 0,
      stores: [],
      data: [],
      surplus_hkd_total: 0,
      transform: '',
      transformnum: 0,
    }
  },
  methods: {
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.stores.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    edit (row) {

      this.$router.push({
        name: '/EditCashAccount',
        path: '/EditCashAccount',
        params: {
          row: row
        }
      })
    },
    getcash () {
      this.data = [];
      this.loading = true;
      this.post('/api/funds/getcash', {
        store_id: this.store_id,

      }).then((res) => {

        this.data = res;
        if (res.length > 0) {
          let total = 0;
          this.data.map(item => {
            total += item.surplus_hkd;
          });

          this.surplus_hkd_total = parseFloat(total).toFixed(2);
        }
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(() => {

      })
    },


    changestore (store_id) {
      this.store_id = store_id;
      this.getcash();

    },

    gotoruter (name) {
      this.$router.push(name)
    },
    getstore () {

      this.loading = true;
      this.post('/api/funds/getstore', {

      }).then((res) => {
        if (res.length > 0) {
          this.store_id = res[0].id;
        }
        this.stores = res;
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(() => {
        this.getcash();

      })


    }

  },
  created () {
    this.getstore();
  }
}
</script>

<style scoped>
.tabletotal {
  background-color: #fafafa;
  padding: 10px;
  border: 1px solid #ebeef5;
  border-top: none;
  display: flex;
  justify-content: space-between;
}
</style>
